// In welke wijk ben je? De kaart kent geen wijkgrenzen, maar elke klant hoort bij een wijk: de wijk van
// een plek is die van de dichtstbijzijnde klant. Is er geen klant in de buurt (open veld), dan geen wijk,
// zodat de melding niet verspringt als je langs de rand rijdt.
import type { Destination } from './orders';

/** Verder dan dit van de dichtstbijzijnde klant telt niet meer als "in de wijk". */
export const DISTRICT_REACH_PX = 900;

export function districtAt(destinations: readonly Pick<Destination, 'id' | 'x' | 'y' | 'districtId'>[], x: number, y: number): string | null {
  let best: string | null = null;
  let bestD = DISTRICT_REACH_PX;
  for (const d of destinations) {
    if (d.id === 'hq') continue;
    const dist = Math.hypot(d.x - x, d.y - y);
    if (dist < bestD) {
      bestD = dist;
      best = d.districtId;
    }
  }
  return best;
}
